<template>
    <div>
        <b-modal 
            no-stacking
            v-model="isShow"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer  
            @hidden="close()" 
            :size="checkSizeModal"   
            body-class="p-0"
            header-class="p-2"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0 ml-2">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3>{{setModalAvoid.title}}</h3>
                        </div>
                    </div>
                </div>
            </template>
            <b-carousel
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="800"
                img-height="455"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
            >
                <b-carousel-slide v-for="(img, index) in setModalAvoid.image" :key="index">
                    <template #img>
                        <img
                            :class="[`d-block w-100` , (index == 0 && $USER_LOGIN.get().isUnderByShippop) ? `cursor-pointer` : ``]"
                            width="800"
                            height="455"
                            :src="img"
                            alt="BANNER"
                            @click="linkImage(index)"
                        >
                    </template>
                </b-carousel-slide>
            </b-carousel>
            <div class="col-lg-12" v-if="isBanner">
                <div class="d-flex justify-content-end">
                    <b-link class="font-weight-bold text-decoration-underline" 
                        @click="notShowToday()">
                        ไม่แสดงวันนี้อีก
                    </b-link>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
const C_NAME = 'bannerAviod'
import { setCookie , getCookie } from "../../helpers/util.js";
export default {
    name: "ModalProductAvoid" ,
    props: {
        productAvoid: Object,
    },
    data() {
        return {
            slide: 0,
            sliding: null,
            show: true
        }
    },
    methods: {
        randomArr( array ){
            let currentIndex = array.length, temporaryValue, randomIndex

            while (0 !== currentIndex) {

                randomIndex = Math.floor(Math.random() * currentIndex)
                currentIndex -= 1

                temporaryValue = array[currentIndex]
                array[currentIndex] = array[randomIndex]
                array[randomIndex] = temporaryValue
            }

            return array
        },
        notShowToday(){
            this.setTimeCookie('24hr')
            this.close()
        },
        close(){
            this.$emit('close')
            this.productAvoid.show = false
        },
        setBanner( time = '4hr' ){
            let res = false
            const get = getCookie( C_NAME )
            if( !get ){
                this.setTimeCookie( time )
                res = true
            }

            return res
        },
        setTimeCookie( time ){
            setCookie( C_NAME , 1 , time )
        },
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        linkImage(index){
            if(index != 0 || !this.$USER_LOGIN.get().isUnderByShippop ){
                return false
            }
            window.open(`https://blog.shippop.com/covid19-delay/`, '_blank')
        }
    },
    computed: {
        checkSizeModal(){
            return this.productAvoid.key == 'insurance' ? 'sm' : 'lg'
        },
        isBanner(){
            return this.productAvoid.isBanner ? this.productAvoid.isBanner : false
        },
        isShow(){
            let res = true
            let prod = this.productAvoid
            if( prod.show && prod.isBanner ){
                res = this.setBanner()
            }else if( prod.show ){
                res = true
            }else{
                res = false
            }

            return res
        },
        setModalAvoid(){
            let ImgForbidden = [
                require(`../../assets/images/productAvoid/product-forbidden-1.png`),
                require('../../assets/images/productAvoid/product-forbidden-2.png'),
                require('../../assets/images/productAvoid/product-forbidden-3.png'),
                require('../../assets/images/productAvoid/product-forbidden-4.png'),
            ]
            let ImgInsurance = [
                require('../../assets/images/productAvoid/product-insurance-1.png'),
                require('../../assets/images/productAvoid/product-insurance-2.png')
            ]
            const ImgDropoffThp = require('../../assets/images/banner/Banner-how-tod-drop-off-thp.png')
            const ImgBanner00 = require('../../assets/images/banner/banner-00.png')
            const ImgCovid19 = require('../../assets/images/banner/Banner-courier-covid-19.png')
            const ImgBannerZendai = require('../../assets/images/banner/Banner-Zendai.png')
            const ImgManageShop = require('../../assets/images/banner/Banner-manage-shop.png')
            const ImgBannerFLE = (this.$THEME.name == 'shippop') ? require('../../assets/images/banner/Banner-FLE-SP.png') : require('../../assets/images/banner/Banner-FLE-WLB.png')

            const ImgBannerDHL = require('../../assets/images/banner/Banner-DHL.png')

            if( this.productAvoid.key == 'insurance' ){
                return {
                    title: "สินค้าที่ไม่อยู่ในประกัน" ,
                    image: ImgInsurance
                }
            }else if(this.productAvoid.key == 'forbidden'){
                return {
                    title: "สินค้าต้องห้าม" ,
                    image: ImgForbidden
                }
            }
            // }else if (this.productAvoid.key == 'banner' ){
            //     ImgForbidden = this.randomArr( ImgForbidden )
            //     let imgBanner = [ ImgBanner00, ImgDropoffThp , ...ImgForbidden ]
               
            //     if( this.$USER_LOGIN.get().isUnderByShippop ){
            //         imgBanner.push( ImgManageShop )
            //         imgBanner.unshift( ImgCovid19 )
            //     }

            //     if( !['postmanservice', 'quickexpress', 'theletter'].includes(this.$THEME.name)){
            //         imgBanner.unshift( ImgBannerFLE )
                    
            //         if( this.$USER_LOGIN.get().isUnderByShippop ){
            //             imgBanner.unshift( ImgBannerZendai )
            //             imgBanner.unshift( ImgBannerDHL )
            //         }
            //     }

            //     return {
            //         title: "ประกาศ" ,
            //         image: imgBanner
            //     }
            // }
            // else{
            //     return {
            //         title: "" ,
            //         image: []
            //     }
            // }
        }
    }
}
</script>
<style scoped>

</style>